import React from 'react'
import moment from 'moment';
import descargar from "../../../../assets/images/descargar.png";
import { useHistory } from "react-router-dom";
import styles from "./SubQuotationsPostulationsItem.module.scss";

const SubQuotationsPostulationsItem = ({ user, file, sub }) => {

    const fecha = moment(sub.createdAt).format('DD-MM-yyyy')
    const history = useHistory();

    const handleClick = () => {
        const userName = user.type === "COMPANY" ? user.razon_social : user.name + " " + user.last_name;
        history.push(`/comunidad-edify/${user.id}/${userName}`)

    }

    return (
        <div className={styles.container}>
            <div className={styles.container_profile}>
                <div className={styles.container_profile_data}>
                    <img src={user.image_profile} onClick={() => handleClick()} alt={"imgProfile"} />
                    <div className={styles.container_profile_data_text}>
                        <p className={styles.container_profile_data_text_nombre} onClick={() => handleClick()} >{`${user.name} ${user.last_name}`}</p>
                        <p className={styles.container_profile_data_text_rubro}>{user.rubro || user.profession}</p>
                    </div>
                </div>
            </div>
            <div className={styles.container_date}>
                <p>Fecha de cotización</p>
            <span>{fecha}</span>
            </div>
            <a target='_blank'
                rel='noopener noreferrer'
                href={file}
                style={{ width: 188, paddingLeft: "10px" }}>
                <div>
                    <img style={{ width: 10, height: 12, marginRight: 8 }} src={descargar} />
                    Descargar cotización
                </div>
            </a>
        </div>
    )

}

export default SubQuotationsPostulationsItem